export default "__VITE_ASSET__CxBqTex$__"